/** 祝日ラジオの選択肢 */
type HolidayRadioOption = {
	id: string;
	label: string;
	value: string;
	hint?: string;
};

/** 宿泊日が祝日のときの扱い（プラン・宿泊可能曜日） */
export const HOLIDAY_STAY_RADIO_OPTIONS: HolidayRadioOption[] = [
	{
		id: "holiday_stay_exclude",
		label: "祝日を宿泊可能にしない",
		value: "false",
		hint: "曜日の設定でチェックがついている日でも、祝日であれば宿泊が許可されません（例: 木曜にチェックがついていても祝日の木曜は対象外となる）",
	},
	{
		id: "holiday_stay_include",
		label: "祝日を宿泊可能にする",
		value: "true",
		hint: "曜日の設定でチェックがついていない日でも、祝日であれば宿泊が許可されます（例: 水曜にチェックがついていなくても祝日の水曜は対象となる）",
	},
	{
		id: "holiday_stay_unset",
		label: "設定しない",
		value: "unset",
		hint: "祝日かどうかは判定せず、曜日の設定のみで対象日を決定します。",
	},
];

export const HOLIDAY_STAY_SECTION_TITLE = "祝日の扱い";
export const HOLIDAY_STAY_SECTION_DESCRIPTION =
	"祝日の扱いを設定します。「設定しない」以外を選んだ場合、曜日の設定よりも祝日の設定が優先されます。";

/** チェックイン日が祝日のときの扱い */
export const HOLIDAY_CHECK_IN_RADIO_OPTIONS: HolidayRadioOption[] = [
	{
		id: "holiday_cin_exclude",
		label: "祝日をチェックイン可能にしない",
		value: "false",
		hint: "曜日の設定でチェックがついている日でも、祝日であればチェックインが許可されません（例: 木曜にチェックがついていても祝日の木曜は対象外となる）",
	},
	{
		id: "holiday_cin_include",
		label: "祝日をチェックイン可能にする",
		value: "true",
		hint: "曜日の設定でチェックがついていない日でも、祝日であればチェックインが許可されます（例: 水曜にチェックがついていなくても祝日の水曜は対象となる）",
	},
	{
		id: "holiday_cin_unset",
		label: "設定しない",
		value: "unset",
		hint: "祝日かどうかは判定せず、曜日の設定のみで対象日を決定します。",
	},
];

export const HOLIDAY_CHECK_IN_SECTION_TITLE = "祝日の扱い";
export const HOLIDAY_CHECK_IN_SECTION_DESCRIPTION =
	"祝日の扱いを設定します。「設定しない」以外を選んだ場合、曜日の設定よりも祝日の設定が優先されます。";

/** オプション販売可能曜日（販売日 basis） */
export const HOLIDAY_SALES_RADIO_OPTIONS: HolidayRadioOption[] = [
	{
		id: "holiday_sales_exclude",
		label: "祝日を販売可能にしない",
		value: "false",
		hint: "曜日の設定でチェックがついている日でも、祝日であれば販売が許可されません（例: 木曜にチェックがついていても祝日の木曜は対象外となる）",
	},
	{
		id: "holiday_sales_include",
		label: "祝日を販売可能にする",
		value: "true",
		hint: "曜日の設定でチェックがついていない日でも、祝日であれば販売が許可されます（例: 水曜にチェックがついていなくても祝日の水曜は対象となる）",
	},
	{
		id: "holiday_sales_unset",
		label: "設定しない",
		value: "unset",
		hint: "祝日かどうかは判定せず、曜日の設定のみで対象日を決定します。",
	},
];

export const HOLIDAY_SALES_SECTION_TITLE = "祝日の扱い（販売日）";
export const HOLIDAY_SALES_SECTION_DESCRIPTION =
	"祝日の扱いを設定します。「設定しない」以外を選んだ場合、曜日の設定よりも祝日の設定が優先されます。";
